import { httpClient } from "@/lib/http-client"

export class User {
  constructor(id: string, name: string, email: string) {
    this.id = id
    this.name = name
    this.email = email
  }

  id: string
  name: string
  email: string
}

export class UserService {
  private static readonly BASE_PATH = "/api/users"

  static getById(userId: string): Promise<User> {
    return httpClient.get<User>(`${this.BASE_PATH}/${userId}`)
  }

  static getUsers(): Promise<User[]> {
    return httpClient.get<User[]>(this.BASE_PATH)
  }
}